module.exports = __webpack_public_path__ + "static/media/this-could-be-you.80123875.txt";